import {
  FloatingFormItem,
  InputDate,
  PlanAccountsSelect,
} from '@/components/_common';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { useReversalBankingEntry } from '@/core/domain/financial/BankingEntry/BankingEntry.hooks';
import {
  BankingEntryListReturn,
  BankingEntryReversalFormValues,
  BankingEntryReversalRequest,
  Destination,
} from '@/core/domain/financial/BankingEntry/BankingEntry.types';
import { Button, Col, Form, Modal, ModalProps, Row } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import { DateTimeFormat } from '@/utils/moment';
import { BankingEntry } from './../../../../core/domain/financial/BankingEntry/BankingEntry.types';
import moment from 'moment';
import { useDefaultEmptyFieldError } from '@/hooks';

type Props = Omit<ModalProps, 'onOk'> & {
  bankingEntryList?: BankingEntryListReturn;
  bankingEntryDetail?: BankingEntry;
  onCancel: () => void;
  handleOkDetail?: (form?: BankingEntryReversalFormValues) => void;
  loadingDetail?: boolean;
};

const BankingEntryReversalModal: React.FC<Props> = ({
  open,
  bankingEntryList,
  bankingEntryDetail,
  onCancel,
  handleOkDetail,
  loadingDetail,
}) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const intl = useIntl();
  const reversalMutation = useReversalBankingEntry();

  const [form] = Form.useForm<BankingEntryReversalFormValues>();

  const handleOk = async () => {
    if (bankingEntryList) {
      const values = await form.validateFields();

      const obj: BankingEntryReversalRequest = {
        ...values,
        id: bankingEntryList.id,
        reversalDate: values.reversalDate.format(DateTimeFormat),
      };

      await reversalMutation.mutateAsync(obj);

      handleCancel();
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={'Estornar'}
      open={open}
      onCancel={handleCancel}
      confirmLoading={reversalMutation.isLoading}
      width={500}
      destroyOnClose
      footer={[
        <Button type="primary" ghost onClick={handleCancel}>
          {intl.formatMessage({ id: 'commons.modal.button.cancel' })}
        </Button>,
        <Button
          type="primary"
          onClick={
            handleOkDetail
              ? async () => handleOkDetail(await form.validateFields())
              : handleOk
          }
          loading={loadingDetail ? loadingDetail : reversalMutation.isLoading}
        >
          {intl.formatMessage({ id: 'commons.modal.button.save' })}
        </Button>,
      ]}
    >
      <Form form={form}>
        <Row gutter={[24, 24]}>
          {!bankingEntryDetail?.transferId && (
            <Col span={24}>
              <FloatingFormItem
                label="Plano de Contas"
                name="planAccountId"
                rules={[defaultEmptyFieldError]}
              >
                <PlanAccountsSelect
                  queryFilter={
                    (
                      bankingEntryList
                        ? bankingEntryList?.destination === Destination.expense
                        : bankingEntryDetail?.nature === Destination.expense
                    )
                      ? {
                          destination: PlanAccountDestination.Revenue,
                          active: true,
                          hierarchy: PlanAccountHierarchy.Analitical,
                        }
                      : {
                          destination: PlanAccountDestination.Expense,
                          active: true,
                          hierarchy: PlanAccountHierarchy.Analitical,
                        }
                  }
                />
              </FloatingFormItem>
            </Col>
          )}

          {/* {bankingEntryDetail?.rateValue && (
            <Col span={24}>
              <FloatingFormItem
                label="Plano de Contas Tarifa"
                name="planAccountTariffId"
                rules={[defaultEmptyFieldError]}
              >
                <PlanAccountsSelect
                  queryFilter={{
                    destination: PlanAccountDestination.Revenue,
                    active: true,
                    hierarchy: PlanAccountHierarchy.Analitical,
                  }}
                />
              </FloatingFormItem>
            </Col>
          )} */}

          <Col span={24}>
            <FloatingFormItem
              label="Data"
              name="reversalDate"
              initialValue={moment()}
            >
              <InputDate />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default BankingEntryReversalModal;
